import { render } from "./NDateInput.vue?vue&type=template&id=6fa96fae&ts=true"
import script from "./NDateInput.vue?vue&type=script&lang=ts"
export * from "./NDateInput.vue?vue&type=script&lang=ts"

import "./NDateInput.vue?vue&type=style&index=0&id=6fa96fae&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__